import API_URL from 'constants/api'

const AVAILABLE_LANGUAGES = ['de-de', 'en-us', 'fr-fr', 'pt-br']
const DEFAULT_LANGUAGE = 'en-us'

/**
 * Sets language configs
 */
class LanguageConfig {
  constructor(prefix) {
    // Translation key prefix for localStorage
    this.i18nPrefix = prefix
  }

  /**
   * Users language. Default: browser language.
   * @return {String}
   */
  get userLanguage() {
    /*
    * TODO
    * When setting configuration in the system is abled, this should be the default.

   */
    let language = navigator.language.toLowerCase()
    if (!AVAILABLE_LANGUAGES.includes(language)) {
      language = DEFAULT_LANGUAGE
    }

    return language
  }

  /**
   * User's last language
   * @return {String}
   */
  get lastUserLanguage() {
    return localStorage.getItem('last_user_lang')
  }

  /**
   * Language in cache (localStorage)
   * @return {Object}
   */
  get i18nCache() {
    return JSON.parse(localStorage.getItem(this.keyI18next()))
  }

  /**
   * Last language update date
   * @return {String}
   */
  get lastUpdateAt() {
    return localStorage.getItem('last_update_user_lang_at')
  }

  /**
   * Saves last date in localStorage
   * @param {Date}
   */
  set storeLanguageLastUpdate(data) {
    localStorage.setItem('last_update_user_lang_at', data)
  }

  /**
   * Saves language key in localStorage
   * @return {String}
   */
  keyI18next() {
    const regex = new RegExp(this.i18nPrefix, 'g')

    for (const key in localStorage) {
      /* istanbul ignore else */
      if (localStorage.hasOwnProperty(key) && key.match(regex)) {
        return key
      }
    }
  }

  /**
   * Saves user's language in localStorage
   */
  storeUserLanguage() {
    localStorage.setItem('last_user_lang', this.userLanguage)
  }

  /**
   * Clears language cache from localStorage
   */
  clearI18nCache() {
    localStorage.removeItem(this.keyI18next())
  }

  /**
   * Checks the last language update from API
   */
  checkLastUpateFromAPI() {
    return fetch(`${API_URL.LOCALES_LAST_UPDATE}/${this.userLanguage}`)
      .then((response) => response.json())
      .then((response) => {
        if (response.data) {
          this.onFetchSuccess(response.data)
        } else {
          this.onFetchError(response)
        }
      })
      .catch((error) => this.onFetchError(error))
  }

  /**
   * Checks if there is a language update, if true, clears language cache
   * and requests the update
   */
  onFetchSuccess(data) {
    const date = data
    /* istanbul ignore else */
    if (this.lastUpdateAt !== date) {
      this.storeLanguageLastUpdate = date
      this.clearI18nCache()
    }
  }

  /**
   * API fetch error handling
   */
  onFetchError(response) {
    // TODO, improve error handling, providing feedback to users
    console.error(response.error)
  }

  /**
   * Checks if there were any changes in language
   * @return {Boolean}
   */
  isChanged() {
    return this.userLanguage !== this.lastUserLanguage
  }
}

export default LanguageConfig
